import React from 'react';
import Button from 'screens/components/basic/Button';
import SelectInput from 'screens/components/basic/SelectInput';
import LOOKUP from 'constants/lookup';
import DatePickerInput from 'screens/components/basic/DatePickerInput';
import VisibilityIcon from '@mui/icons-material/Visibility';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import BranchSelectAutoCompleteInput from 'screens/components/basic/BranchSelectAutoCompleteInput';
import CardSimple from 'screens/components/basic/CardSimple';

const componentName = "CategoryProducts";

const Header = (props) => (
    <CardSimple className="p-1">
        <div className="row row_margin_none">
            <div className="col-xs-6 col-sm-6 col-md-4">
                <DatePickerInput
                    name={componentName + "Date"}
                    floatingLabelText={"Date"}
                    hintText={"Date"}
                    fullWidth={true}
                    required
                />
            </div> {/* .col */}

            <div className="col-xs-6 col-sm-6 col-md-4">
                <BranchSelectAutoCompleteInput
                    name={componentName + LOOKUP.report.common.branchName}
                    label={LOOKUP.report.common.branch + "*"}
                />
            </div> {/* .col */}
            <div className="col-xs-12 col-sm-6 col-md-4">
                <SelectInput
                    name={componentName + "IsCannabis"}
                    fullWidth={true}
                    defaultValue="2"
                    label={"Type"}
                    floatingLabelText={"Type"}
                    hintText={"Type"}
                    options={props.isCannabisOptions && props.isCannabisOptions.length > 0 ? props.isCannabisOptions : []}
                />
            </div> {/* .col */}
            <div className="col-xs-12 col-sm-6 col-md-4">
                <SelectInput
                    name={componentName + "SelectedCategory"}
                    fullWidth={true}
                    label={"Category"}
                    floatingLabelText={"Category"}
                    hintText={"Category"}
                    defaultValue={"0"}
                    options={(() => {
                        const categoryOptions = props.categories || [];
                        const filteredCategories =
                            props.isCannabis === 0
                                ? categoryOptions.filter(x => !x.isCannabis)
                                : props.isCannabis === 1
                                    ? categoryOptions.filter(x => x.isCannabis)
                                    : categoryOptions;

                        return [{ text: "All", value: "0" }, ...filteredCategories.filter(x => x.value !== "0")];
                    })()}

                />
            </div> {/* .col */}

            <div className="col-xs-6 col-sm-6 col-md-4">
                <DatePickerInput
                    name={componentName + "ComparisonDate"}
                    floatingLabelText={"Comparison Date"}
                    hintText={"Comparison Date"}
                    fullWidth={true}
                    required
                />
            </div> {/* .col */}

            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                <Button
                    type="IconInButton"
                    className="pull-right mt-2 ml-1 btnNewBrandPOS"
                    name={componentName + LOOKUP.report.common.viewReport.name}
                    label={LOOKUP.report.common.viewReport.label}
                    icon={<VisibilityIcon />}
                    onTouchTap={props.showBody}
                />
                <Button
                    type="DownloadButton"
                    className="pull-right mt-2 btnNewBrandPOS"
                    name={componentName + LOOKUP.report.common.downloadReport.name}
                    label={LOOKUP.report.common.downloadReport.label}
                    onTouchTap={props.download}
                />
            </div>
        </div>
    </CardSimple>
);

export default Header;
